module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "create-container"
  }, [_c('el-dialog', {
    attrs: {
      "title": "设计图片",
      "close-on-click-modal": false,
      "visible": _vm.dialogVisible,
      "destroy-on-close": true,
      "width": "52%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('span', {
    staticClass: "text-group",
    attrs: {
      "type": "text"
    }
  }, [_vm._v("文字")]), _vm._v(" "), _c('create-base', {
    on: {
      "cUpdateColor": _vm.updateColor,
      "cUpdateText": _vm.updateText,
      "cUpdateSize": _vm.updateSize,
      "cUpdateFamily": _vm.updateFamily,
      "cUpdateWeight": _vm.updateWeight,
      "cUpdateItalic": _vm.updateItalic
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-group",
    attrs: {
      "type": "text"
    }
  }, [_vm._v("背景")]), _vm._v(" "), _c('create-background', {
    on: {
      "cUpdateBg": _vm.updateBg
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-group",
    attrs: {
      "type": "text"
    }
  }, [_vm._v("预览")]), _vm._v(" "), _c('preview-canvas', {
    ref: "previewRef"
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "background": "#009e7d"
    },
    attrs: {
      "type": "success",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.saveBlobCanvas
    }
  }, [_vm._v("确 定")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-546a99bc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/operation/components/createPicture.vue
// module id = 692
// module chunks = 1